<template>
  <div class="tab-wrap">
    <!-- 탭메뉴 -->
    <tabMenu />

    <!-- // 탭메뉴 -->
    <!-- 검색 화면 -->
    <div v-if="searchingPage" class="pt20 pr20 pl20 fs14">
      <!-- 거래종류 -->
      <div flex fjb>
        <p>거래종류</p>
        <div class="orer-type-wrap" flex fjb>
          <el-radio
            v-model="orderType"
            label
            @change="getList({ page: 1 })"
            class="order-type"
          >
            {{ $t("tradeLog.Total") }}
          </el-radio>
          <el-radio
            v-model="orderType"
            label="B"
            @change="getList({ page: 1 })"
            class="order-type"
          >
            {{ $t("tradeLog.Buy") }}
          </el-radio>
          <el-radio
            v-model="orderType"
            label="S"
            @change="getList({ page: 1 })"
            class="order-type"
          >
            {{ $t("tradeLog.Sell") }}
          </el-radio>
        </div>
      </div>
      <!-- //거래종류 -->
      <!-- 코인 -->
      <div flex fjb class="mt20">
        <p>코인</p>
        <button
          @click="clickCoinListButton"
          class="select-coin-button"
          :class="{ select: selectedCoin !== '0' }"
        >
          {{ selectedCoin == "전체" ? "전체" : selectedCoin }}
        </button>
      </div>
      <!-- //코인 -->
      <!-- 조회기간 -->
      <div class="date-search-wrap mt20">
        <div class="block">
          <p class="demonstration">조회기간</p>
          <div class="mt10 fs12" flex fjb>
            <a
              :class="{ on: durationDays === 0 }"
              href="#"
              @click.prevent="dateSel('today')"
              class="duration"
            >
              {{ $t("tradeLog.today") }}
            </a>
            <!-- <a
              :class="{ on: durationDays === 3 }"
              href="#"
              @click.prevent="dateSel(3, 'days')"
              class="duration"
            >
              {{ $t("tradeLog.3days") }}
            </a> -->
            <a
              :class="{ on: durationDays === 7 }"
              href="#"
              @click.prevent="dateSel(1, 'week')"
              class="duration"
            >
              {{ $t("tradeLog.1week") }}
            </a>
            <a
              :class="{ on: isAMonthAgo }"
              href="#"
              @click.prevent="dateSel(1, 'month')"
              class="duration"
            >
              {{ $t("tradeLog.1month") }}
            </a>
            <a
              :class="{ on: is3MonthAgo }"
              href="#"
              @click.prevent="dateSel(3, 'months')"
              class="duration"
            >
              {{ $t("tradeLog.3months") }}
            </a>
            <a
              :class="{ on: is6MonthAgo }"
              href="#"
              @click.prevent="dateSel(6, 'months')"
              class="duration"
            >
              {{ $t("tradeLog.6months") }}
            </a>
          </div>
          <div class="mt10" flex fjb>
            <el-date-picker
              v-model="tradeStartDate"
              placeholder="날짜 선택"
              value-format="yyyy-MM-dd"
              class="search-date"
            ></el-date-picker>
            <p class="pt7">~</p>
            <el-date-picker
              v-model="tradeEndDate"
              placeholder="pick a date"
              value-format="yyyy-MM-dd"
              class="search-date"
            ></el-date-picker>
          </div>
        </div>
      </div>
      <!-- //조회기간 -->
      <div flex fjb>
        <button class="pre" @click="moveToHistory">{{ "이전" }}</button>
        <button class="search" @click="getTradingHistory">
          {{ $t("trade.log.search") }}
        </button>
      </div>
    </div>
    <!-- //검색 화면 -->
    <!-- 코인 선택 -->
    <div v-else-if="selectCoinPage" class="select-coin-wrap pt12 pl12">
      <div @click="searchHistory" class="icon-close">
        <i class="el-icon-close"></i>
      </div>
      <!-- <el-radio-group
        v-for="(coin, index) in coinList"
        :key="index"
        v-model="selectedCoin"
        @change="select"
        class="select-coin"
      > -->
      <el-radio
        v-model="selectedCoin"
        :label="`전체`"
        class="pt10 pb10"
        @change="select"
      ></el-radio>
      <el-radio-group
        v-for="(coin, index) in coinList"
        :key="index"
        v-model="selectedCoin"
        @change="select"
        class="select-coin"
      >
        <el-radio
          :label="`${coin.name}(${coin.code})`"
          class="pt10 pb10"
        ></el-radio>
      </el-radio-group>
    </div>
    <!-- //코인 선택 -->
    <!-- 검색 결과 -->
    <div v-else class="list-container">
      <!-- 검색 버튼 -->
      <div @click="searchHistory" class="searching-requirement pl12" flex>
        <i class="el-icon-s-operation mt3 keycolor"></i>
        <p>{{ dateEnd }} ~ {{ dateStart }}</p>
        <p>
          {{
            orderType == "" ? "매수/매도" : orderType == "B" ? "매수" : "매도"
          }}
        </p>
        <p>
          {{ selectedCoin == 0 ? "코인 전체" : selectedCoin }}
        </p>
      </div>
      <div class="TransactionHistory">
        <div class="TransactionHistory__header">
          <div
            v-for="(headers, index) in tableHeader"
            :key="index"
            class="TransactionHistory__row"
          >
            <div
              v-for="(header, headerIndex) in headers"
              :key="headerIndex"
              class="TransactionHistory__content"
            >
              {{ header }}
            </div>
          </div>
        </div>
        <div
          v-for="(tradingList, index) in tradingHistory"
          :key="index"
          class="TransactionHistory__body"
        >
          <div class="TransactionHistory__row">
            <div class="TransactionHistory__content">
              {{ tradingList.date.split(" ")[0] }}<br />
              {{ tradingList.date.split(" ")[1] }}
            </div>
          </div>
          <div class="TransactionHistory__row">
            <div class="TransactionHistory__content">
              {{ tradingList.coinCode }}/{{ tradingList.baseCoinCode }}
            </div>
            <div class="TransactionHistory__content">
              <span
                :class="tradingList.oc_type === 'B' ? 'txt-red' : 'txt-blue'"
              >
                {{
                  tradingList.oc_type === "B"
                    ? $t("trade.orderBook.buy")
                    : $t("trade.orderBook.sell")
                }}
              </span>
            </div>
          </div>
          <div class="TransactionHistory__row">
            <div class="TransactionHistory__content">
              {{ tradingList.chePrice }}
            </div>
            <div class="TransactionHistory__content">
              {{ tradingList.cheAmount }}
            </div>
          </div>
          <div class="TransactionHistory__row">
            <div class="TransactionHistory__content">
              <span
                v-if="
                  tradingList.fee !== '0' ||
                    (tradingList.fee === '0' && tradingList.coinFee === '0')
                "
              >
                {{ feeFormat(tradingList.fee, tradingList.baseCoinCode) }}
              </span>
              <span v-else>
                {{ tradingList.coinFee }} {{ tradingList.coinCode }}
              </span>
            </div>
            <div class="TransactionHistory__content">
              {{
                totalFormat(
                  tradingList.cheAmount * tradingList.chePrice,
                  tradingList.baseCoinCode
                )
              }}
            </div>
          </div>
        </div>
      </div>
      <Pagination
        v-if="tradingHistory.length != 0"
        :current-page="tradingHistoryPage.currentPage"
        :total-page="tradingHistoryPage.totalPage"
        @next-page="nextPage('getTradingHistory')"
        @prev-page="prevPage('getTradingHistory')"
        class="mb20"
      ></Pagination>
    </div>
    <!-- //검색 결과 -->
  </div>
</template>
<script>
import Decimal from "decimal.js";

import { mapGetters, mapState } from "vuex";

import Pagination from "@/components/common/pagination";
import Store from "@/store/";
import Moment from "moment";
import Api from "@/common/Api";
import TabMenu from "@/components/investments/tabMenu";

export default {
  data() {
    return {
      tableHeader: [
        [`체결시간`],
        [`마켓`, `주문`],
        [`체결가격`, `체결수량`],
        [`수수료`, `체결대금`],
      ],
      actives: 0,
      tradeStartDate: this.moment()
        .subtract(1, "M")
        .format("YYYY-MM-DD"),
      tradeEndDate: this.moment().format("YYYY-MM-DD"),
      KRWStartDate: this.moment()
        .subtract(1, "M")
        .format("YYYY-MM-DD"),
      KRWEndDate: this.moment().format("YYYY-MM-DD"),
      coinStartDate: this.moment()
        .subtract(1, "M")
        .format("YYYY-MM-DD"),
      coinEndDate: this.moment().format("YYYY-MM-DD"),
      tradingHistory: [],
      krwDepositWithdrawLists: [],
      coinDepositWithdrawLists: [],
      /** pagenation */
      tradingHistoryPage: {
        currentPage: 1,
        totalPage: 1,
        method: this.getTradingHistory,
      },
      krwHistoryPage: {
        currentPage: 1,
        totalPage: 1,
        method: this.getKRWHistory,
      },
      coinHistoryPage: {
        currentPage: 1,
        totalPage: 1,
        method: this.getCoinHistory,
      },
      options1: [
        { text: "IT", value: 0 },
        { text: "Blade Runner", value: 1 },
        { text: "Thor Ragnarok", value: 2 },
      ],
      searchingPage: false,
      selectCoinPage: false,
      selectedCoin: "전체",
      orderType: "",
      dateStart: Moment(
        Moment()
          .subtract(1, "month")
          .startOf("day")
          .toDate()
      ).format("YYYY-MM-DD"),
      dateEnd: Moment(
        Moment()
          .endOf("day")
          .toDate()
      ).format("YYYY-MM-DD"),
      countPerPage: 10,
      selectedCoinId: "",
      page: {},
    };
  },
  computed: {
    ...mapGetters([
      "totalAssetToKRW",
      "marketsByDealCoin",
      "totalAvailToKRW",
      "toKRW",
      "wallet",
      "coinWallet",
    ]),
    ...mapState(["Server"]),
    coins() {
      return _.map(this.wallet, (wallet) => {
        return {
          name: wallet.coin.name,
          img: `//static.flybit.com/static/img/mobile/coin_${wallet.coin.code}.png`,
          amount: wallet.total,
          tokrw: new Decimal(this.toKRW(this.$bnCode(wallet.coin.code)).price)
            .mul(wallet.total)
            .toNumber(),
          available: wallet.available,
          code: wallet.coin.code,
          active: wallet.coin.enable === "Y",
          availMarkets: (code) => {
            const availMarkets = _.get(
              this.marketsByDealCoin,
              wallet.coin.code,
              []
            ).map((market) => market.baseCoinCode);
            return availMarkets.includes(code);
          },
        };
      });
    },
    coinList() {
      const coinList = this._.map(this.$store.state.Market.coin).filter(
        (coins) => coins.code !== "KRW"
      );
      return _.sortBy(coinList, ["sort"]);
    },
    durationDays() {
      return Moment.duration(
        Moment(this.tradeEndDate).startOf("day") - this.tradeStartDate
      ).as("d");
    },
    isAMonthAgo() {
      const ago = Moment(this.tradeEndDate)
        .subtract(1, "month")
        .startOf("day");
      return +this.tradeStartDate === +ago;
    },
    is3MonthAgo() {
      const ago = Moment(this.tradeEndDate)
        .subtract(3, "months")
        .startOf("day");
      return +this.tradeStartDate === +ago;
    },
    is6MonthAgo() {
      const ago = Moment(this.tradeEndDate)
        .subtract(6, "months")
        .startOf("day");
      return +this.tradeStartDate === +ago;
    },
  },
  mounted() {
    this.getTradingHistory();
    this.getKRWHistory();
    this.getCoinHistory();
  },
  methods: {
    totalFormat(fee, baseCoin) {
      if (baseCoin === "KRW") {
        return parseInt(fee);
      }

      const unit = Math.floor(fee * 1000000) / 1000000;
      return unit.toFixed(6);
    },
    feeFormat(fee, baseCoin) {
      if (baseCoin === "KRW") {
        console.log(fee);
        const unit = Math.floor(fee * 100) / 100;
        return unit.toFixed(2);
      }

      return fee;
    },
    moveToHistory() {
      this.searchingPage = false;
      this.selectCoinPage = false;
    },
    getTradingHistory() {
      if (this.selectedCoin !== "전체") {
        const selectedCoinOj = _.find(
          this.coinList,
          (ele) => ele.name === this.selectedCoin.split("(")[0]
        );
        this.selectedCoinId = selectedCoinOj.id;
      } else {
        this.selectedCoinId = "";
      }

      const params = {
        cidx: this.selectedCoinId,
        completed: "Y",
        fromDate: this.moment(this.tradeStartDate).toISOString(),
        toDate: this.moment(this.tradeEndDate).toISOString(),
        page: this.tradingHistoryPage.currentPage,
        count: 10,
        orderType: this.orderType,
      };
      this.$api.User.tradeOrderHistory(params).then((response) => {
        this.tradingHistoryPage.totalPage =
          response.pagination.totalPages === 0
            ? 1
            : response.pagination.totalPages;
        this.tradingHistory = response.body;
      });
      this.selectCoinPage = false;
      this.searchingPage = false;
    },
    getKRWHistory() {
      const params = {
        fromDate: this.moment(this.KRWStartDate).toISOString(),
        toDate: this.moment(this.KRWEndDate).toISOString(),
        page: this.krwHistoryPage.currentPage,
        count: 10,
      };
      return this.$api.Transfer.getKRWTransferHistory(params).then(
        (response) => {
          this.krwHistoryPage.totalPage =
            response.pagination.totalPages === 0
              ? 1
              : response.pagination.totalPages;
          this.krwDepositWithdrawLists = response.body;
        }
      );
    },
    getCoinHistory() {
      const params = {
        fromDate: this.moment(this.coinStartDate).toISOString(),
        toDate: this.moment(this.coinEndDate).toISOString(),
        page: this.coinHistoryPage.currentPage,
        count: 10,
      };
      return this.$api.Transfer.getTransferHistory(params).then((response) => {
        //this.coinDepositWithdrawLists = response.body;
        this.coinHistoryPage.totalPage =
          response.pagination.totalPages === 0
            ? 1
            : response.pagination.totalPages;
        this.coinDepositWithdrawLists = _.map(response.body, (row) => {
          return {
            ...row,
            coinCode: _.get(Store.getters, ["coinIdMap", row.coinId, "code"]),
          };
        });
      });
    },
    nextPage(board) {
      const page = this.getPagination(board);
      if (page.currentPage < page.totalPage) {
        page.currentPage++;
        page.method();
      }
    },
    prevPage(board) {
      const page = this.getPagination(board);
      if (page.currentPage > 1) {
        page.currentPage--;
        page.method();
      }
    },
    getPagination(board) {
      switch (board) {
        case "getTradingHistory":
          return this.tradingHistoryPage;
          break;
        case "getKRWHistory":
          return this.krwHistoryPage;
          break;
        case "getCoinHistory":
          return this.coinHistoryPage;
          break;
      }
    },
    searchHistory() {
      this.searchingPage = true;
      this.selectCoinPage = false;
    },
    clickCoinListButton() {
      this.selectCoinPage = true;
      this.searchingPage = false;
    },
    select() {
      window.scrollTo(0, 0);
      this.searchingPage = true;
      this.selectCoinPage = false;
    },
    async getList(params = {}) {
      let marketId = 0;

      // 검색 기간 1년 내로 제한
      if (Moment(this.tradeEndDate).diff(this.tradeStartDate, "days") > 365) {
        this.$notify({
          title: this.$t("notify.type.info"),
          message:
            "최대 검색 기간은 1년입니다. 검색 기간을 다시 설정해 주세요.",
          type: "warning",
          customClass: "dexko-noti",
          position: "top-left",
        });
        return false;
      }
      //orderHis
      let _params = {
        orderType: this.orderType,
        completed: "Y",
        fromDate: Moment(this.tradeStartDate).toISOString(),
        toDate: Moment(this.tradeEndDate).toISOString(),
        page: 1,
        count: this.countPerPage,
        cidx: this.$store.getters.getCoinSetting(this.coinId).id || 0,
        ...params,
      };
      await Api.User.tradeOrderHistory(_params).then((response) => {
        this.pagination = { ...response.pagination };
        this.page.currentPage = _params.page;
        this.tradeHistory = response.body;
      });
    },
    changePage() {
      this.getList({ page: this.page.currentPage });
    },
    dateSel(duration, unit) {
      this.tradeEndDate = Moment()
        .endOf("day")
        .toDate();
      this.tradeStartDate = Moment()
        .subtract(duration, unit)
        .startOf("day")
        .toDate();
      this.getList({ page: 1 });
      this.dateStart = Moment(
        Moment()
          .endOf("day")
          .toDate()
      ).format("YYYY-MM-DD");
      this.dateEnd = Moment(
        Moment()
          .subtract(duration, unit)
          .startOf("day")
          .toDate()
      ).format("YYYY-MM-DD");
    },
  },
  components: {
    Pagination,
    TabMenu,
  },
};
</script>
<style lang="scss" scoped>
// radio 버튼 스타일 custom.scss
p {
  margin-bottom: 0;
}
.scrollX {
  overflow-x: scroll;
  height: 48px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  .investList-menu {
    width: 454px;
    padding: 7px 12px;
    list-style: none;
    li {
      min-width: 88px;
      padding: 0 6px;
      margin-right: 8px;
      border: 1px solid #dcdfe3;
      border-radius: 52px;
      text-align: center;
      background-color: #fff;
      line-height: 32px;
      font-size: 12px;
      font-weight: normal;
      color: #333;
      &.active {
        border-color: #eb3246;
        background-color: #eb3246;
        color: #fff;
      }
    }
    a:last-child li {
      margin-right: 0;
    }
  }
}
.searching-requirement {
  border: 1px solid rgba(#afafaf, 0.5);
  display: flex;
  align-items: center;
  padding: 10px 5px;
  border-radius: 4px;
  margin: 10px;

  p {
    font-size: 10px;
    margin-left: 5px;
  }
}
.select-coin-wrap {
  position: relative;

  .icon-close {
    position: absolute;
    top: 12px;
    right: 12px;
  }
}
.el-radio-group.select-coin {
  width: 100%;
}
.search-date.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px;
}
button {
  &.select-coin-button {
    width: calc(100% - 100px);
    border: 1px solid #00b473;
    border-radius: 2px;
    font-size: 12px;
    color: #333;
    background-color: #f2fbf8;
  }
  &.pre {
    width: 96px;
    padding: 10px;
    margin-top: 10px;
    margin-right: 8px;
    border-radius: 2px;
    border: solid 1px #eeeeee;
    font-size: 12px;
    line-height: 1;
    color: #333;
    background-color: #fff;
  }
  &.search {
    width: calc(100% - 104px);
    padding: 10px;
    margin-top: 10px;
    border-radius: 2px;
    font-size: 12px;
    line-height: 1;
    color: #fff;
    background-color: #00b473;
  }
}
a.duration {
  width: calc(96% / 5);
  padding: 4px 10px;
  border: 1px solid #dcdfe3;
  border-radius: 2px;
  color: #333;
  text-align: center;
  &.on {
    background-color: #f2fbf8;
    border-color: #00b473;
  }
}

.TransactionHistory {
  margin-bottom: 30px;
  &__body,
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    font-size: 11px;
    font-weight: 400;
    color: #333;
    background: #fafafa;
    border-top: 1px solid #999;
    border-bottom: 1px solid #999;
  }

  &__body {
    background: #fff;
    border-top: 0;
  }

  &__row {
    border-left: 1px solid #e6e6e6;
    flex-basis: 25%;

    &:first-child {
      border-left: 0;
    }
  }

  &__content {
    padding: 5px 0;
    border-bottom: 1px solid #e6e6e6;

    &:last-child {
      border-bottom: 0;
    }
  }
}
</style>
